import React from 'react';
import PropTypes from 'prop-types';
import { GoogleMap, LoadScript, Marker } from '@react-google-maps/api';

const libraries = ["places"]
const region = ['PH']

const Location = ({ value }) => {

  const [lat, lng] = value.split(',')
  const position = value ? {
    lat: +lat,
    lng: +lng
  } : {
    lat: 14.5964957,
    lng: 120.9445404
  }

  if(!value){
    return (
      <div className="text-center py-3"><b>LOCATION NOT FOUND</b></div>
    )
  }

  return (
    <div className="p-1">
      <LoadScript
        region={region}
        libraries={libraries} 
        googleMapsApiKey={process.env.REACT_APP_GOOGLE_MAP_KEY}
      >
        <GoogleMap
          mapContainerStyle={{
            width: '100%',
            height: '400px'
          }}
          center={position}
          zoom={12}
        >
          <Marker position={position} />  
        </GoogleMap>
      </LoadScript>
    </div>
  )
}

Location.propTypes = {
  value: PropTypes.string.isRequired
}

export default Location 